import Axios from "@/plugins/Axios";

const BASE_URL = "busca-ativa";

export class BuscaAtivaService {
  async regrasClassificacao() {
    const response = await Axios().get(`${BASE_URL}/regras-classificacao`);

    return response.data;
  }

  async visaoGeral() {
    const response = await Axios().get(`${BASE_URL}/visao-geral`);

    return response.data;
  }

  async opcoesDeFiltro() {
    const response = await Axios().get(`${BASE_URL}/opcoes-de-filtro`);

    return response.data;
  }

  async casos(params = {}) {
    const response = await Axios().get(`${BASE_URL}/casos`, { params });

    return response.data;
  }

  async turmasComIncidencia(params = {}) {
    const response = await Axios().get(`${BASE_URL}/turmas-com-incidencia`, { params });

    return response.data;
  }

  async caso(casoId) {
    const response = await Axios().get(`${BASE_URL}/casos/${casoId}`);

    return response.data.data;
  }

  async historicoFrequencia(casoId, params = {}) {
    const response = await Axios().get(`${BASE_URL}/casos/${casoId}/historico-frequencia`, {
      params,
    });

    return response.data;
  }

  async linhaDoTempo(casoId) {
    const response = await Axios().get(`${BASE_URL}/casos/${casoId}/linha-do-tempo`);

    return response.data;
  }

  async opcoesDeAcompanhamento() {
    const response = await Axios().get(`${BASE_URL}/opcoes-de-acompanhamento`);

    return response.data;
  }

  async registrarAcompanhamento(casoId, dados) {
    const response = await Axios().post(`${BASE_URL}/casos/${casoId}/acompanhamentos`, dados);

    return response.data;
  }

  async relatorio(params = {}) {
    const response = await Axios().get(`${BASE_URL}/relatorio`, {
      params,
      responseType: "arraybuffer",
    });
    const blob = new Blob([response.data], { type: "application/pdf" });
    window.open(window.URL.createObjectURL(blob));

    return response;
  }

  async encerrarCaso(casoId, justificativa) {
    const response = await Axios().post(`${BASE_URL}/casos/${casoId}/encerrar`, { justificativa });

    return response.data;
  }
}

export default new BuscaAtivaService();
